import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromServiceConfiguration from './service-configuration.reducer';

export const selectServiceConfigurationState = createFeatureSelector<fromServiceConfiguration.State>(
  fromServiceConfiguration.serviceConfigurationFeatureKey
);

export const selectExpandedSections = createSelector(
  selectServiceConfigurationState,
  serviceConfigurationState => serviceConfigurationState.expandedSections
);

export const selectDynamicTickets = createSelector(selectServiceConfigurationState, state => state.dynamicTickets);
export const selectDynamicTicketsLoading = createSelector(
  selectServiceConfigurationState,
  state => state.dynamicTicketLoading
);

export const selectOpenDynamicTicketCreationModal = createSelector(
  selectServiceConfigurationState,
  state => state.openDynamicTicketCreationModal
);

export const selectProjectTypes = createSelector(selectServiceConfigurationState, state => state.projectTypes);

export const selectOpenProjectTypeCreationModal = createSelector(
  selectServiceConfigurationState,
  state => state.openProjectTypeCreationModal
);
